import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/app/providers.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/styles/prosemirror.css");
import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/styles/globals.css")